<template>
  <div :class="['button-group', direction]">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ButtonGroup',
  props: {
    direction: {
      type: String,
      default: 'row'
    }
  }
}
</script>

<style scoped>
.button-group {
  display: flex;
  justify-content: center;
  flex-direction: row;
  width: 100%;
}
.button-group > * {
  margin: 0.5rem;
}
.column {
  flex-direction: column;
}
</style>
